import countriesCities from '../data/countries_cities.json';

const findCountryByCity = (cityName) => {
    if (!cityName) return null;
    for (const countryData of countriesCities) {
        if (countryData.cities && countryData.cities.includes(cityName)) {
            return countryData.country;
        }
    }
    return null;
};

export const getTripTitle = (trip) => {
    if (!trip.locations) return trip.name;

    const locations = trip.locations.split('|');
    const countries = [];
    const seenCountries = new Set();

    locations.forEach(location => {
        if (!location) return;
        const parts = location.split(',').map(p => p.trim());
        let country = null;

        const potentialCountry = parts[parts.length - 1];
        const isKnownCountry = countriesCities.some(c => c.country === potentialCountry);

        if (isKnownCountry) {
            country = potentialCountry;
        } else {
            country = findCountryByCity(parts[0]);
        }

        if (country && !seenCountries.has(country)) {
            seenCountries.add(country);
            countries.push(country);
        }
    });

    return countries.length > 0 ? countries.join(', ') : trip.name;
};
